import { useState, useCallback } from "react";

export interface ContextMenuState<T> {
  readonly isOpen: boolean;
  readonly position: { readonly x: number; readonly y: number };
  readonly data: T | null;
}

export interface UseContextMenuResult<T> {
  readonly state: ContextMenuState<T>;
  readonly open: (event: React.MouseEvent, data: T) => void;
  readonly close: () => void;
}

const CLOSED_STATE = { isOpen: false, position: { x: 0, y: 0 }, data: null } as const;

export function useContextMenu<T>(): UseContextMenuResult<T> {
  const [state, setState] = useState<ContextMenuState<T>>(
    CLOSED_STATE as ContextMenuState<T>,
  );

  const open = useCallback((event: React.MouseEvent, data: T) => {
    event.preventDefault();
    setState({ isOpen: true, position: { x: event.clientX, y: event.clientY }, data });
  }, []);

  const close = useCallback(() => {
    setState(CLOSED_STATE as ContextMenuState<T>);
  }, []);

  return { state, open, close };
}
